interface UseFieldsAriaAttributesParams {
  ariaLabel?: string
  ariaLabelledBy?: string
  label?: string
  labelId?: string
}

export const useControlAriaAttributes = ({
  ariaLabel,
  ariaLabelledBy,
  label,
  labelId,
}: UseFieldsAriaAttributesParams) => {
  const ariaAttributes = ariaLabelledBy
    ? { 'aria-labelledby': ariaLabelledBy }
    : label
      ? { 'aria-labelledby': labelId }
      : { 'aria-label': ariaLabel }
  return { ariaAttributes }
}
